import { httpApi } from '@api/http.api.ts';
import type {
    ANSWER_STATUS,
    COMMON_QUIZ_STATUS,
    QUIZ_NOTIFICATION,
} from '@routes/sidebar/learning/___pages___/learning-overview/ui/overview/quiz/___shared___/constants.ts';

type CommonQuizStatus = (typeof COMMON_QUIZ_STATUS)[keyof typeof COMMON_QUIZ_STATUS];

// keep in this way, just in case if we need to add more statuses in the future
export type AdaptiveQuizStatus = CommonQuizStatus;
export type AnswerStatus = (typeof ANSWER_STATUS)[keyof typeof ANSWER_STATUS];
export type QuizNotification = (typeof QUIZ_NOTIFICATION)[keyof typeof QUIZ_NOTIFICATION];

export interface AdaptiveQuizInfoResponse {
    maxAttempts: number;
    attempt: number;
    numberOfQuestions: number;
    durationInSeconds: number;
    requiredPercentScore: number;
    highestPercentScore: number;
    currentPercentScore: number;
    approach: number;
    quizStatus: AdaptiveQuizStatus;
    quizNotification: QuizNotification;
    startedAtUTC: string;
    finishedAtUTC: string;
    quizEndsAtUTC: string;
    pathwayItemsToReview: number[];
}

export interface AdaptiveQuizUserQuestionsResponse {
    adaptiveQuizQuestion: QuizQuestion[];
    adaptiveQuizDescription: AdaptiveQuizInfoResponse;
}

export interface QuizAnswer {
    id: number;
    text: string;
    questionId: number;
}

export interface AdaptiveQuizAnswerRequest {
    answersIds: number[];
    questionId: number;
}

export interface QuizAnswerResponse {
    correct: number[];
    quizQuestionAnswerStatus: AnswerStatus;
}

export interface QuizQuestion {
    id: number;
    questionText: string;
    answers: QuizAnswer[];
    userAnswers: number[];
    correctAnswers: number[];
    selectAllRight: boolean;
    quizQuestionAnswerStatus: AnswerStatus;
    introText: string | null;
    outroText: string | null;
}

export const getApiAdaptiveQuizData = (pathwayId: string, quizId: number): Promise<AdaptiveQuizInfoResponse> =>
    httpApi.get<AdaptiveQuizInfoResponse>(`learning/${pathwayId}/adaptive-quiz/${quizId}`).then(({ data }) => data);

export const postApiAdaptiveQuizStart = (
    pathwayId: string,
    quizId: number,
): Promise<AdaptiveQuizUserQuestionsResponse> =>
    httpApi
        .post<AdaptiveQuizUserQuestionsResponse>(`learning/${pathwayId}/adaptive-quiz-start/${quizId}`, {})
        .then(({ data }) => data);

export const postApiAdaptiveQuizAnswer = (
    payload: AdaptiveQuizAnswerRequest,
    quizId: number,
    pathwayId: string,
): Promise<QuizAnswerResponse> =>
    httpApi
        .post<QuizAnswerResponse>(`learning/${pathwayId}/adaptive-quiz-answer/${quizId}`, {
            ...payload,
        })
        .then(({ data }) => data);

export const postApiAdaptiveQuizFinish = (pathwayId: string, quizId: number): Promise<AdaptiveQuizInfoResponse> =>
    httpApi
        .post<AdaptiveQuizInfoResponse>(`learning/${pathwayId}/adaptive-quiz-finish/${quizId}`, {})
        .then(({ data }) => data);
